import React from 'react';

import Link from 'next/link';
import { useLocale } from 'next-intl';
import styled from 'styled-components';

import { RowHeaderWrapper } from './RowHeaderCell';
import { Monospace } from '../Table/Table.styled';
import Icon from '@/ui/components/Icon';
import { urlBuilder } from '@/utils/urlBuilder';

const WrapperWithIndent = styled(RowHeaderWrapper)`
  a {
    color: black;
    line-height: 16px;
    text-decoration: underline;
  }
`;

const ShopLink = styled.a`
  color: ${({ theme }) => theme.custom.colors.brand} !important;
  text-decoration: none;
`;

const LinkToShop = ({ row }) => {
  const link = row.original.eshop_url;

  if (!link) return null;

  return (
    <ShopLink href={link} target="_blank" rel="nofollow noreferrer">
      <Icon name="shopping-cart" style="solid" />
    </ShopLink>
  );
};

export default function RowHeaderSubrowCell({ row }) {
  const locale = useLocale();

  const postLink = {
    slug: row.original.post?.slug,
    type: 'helps',
  };

  if (row.original.post?.slug) {
    return (
      <WrapperWithIndent>
        <Link href={urlBuilder({ locale, item: postLink })}>
          <Monospace>{row.original.brand}</Monospace>
        </Link>
        <LinkToShop row={row} />
      </WrapperWithIndent>
    );
  }

  return (
    <WrapperWithIndent>
      <Monospace>{row.original.brand}</Monospace>
      <LinkToShop row={row} />
    </WrapperWithIndent>
  );
}
